/**
 * Choice-control family (new design-system primitives).
 *
 * Lives under `QDropdowns` so legacy `components/QMenu` is untouched.
 *
 * Layout:
 * - `shared/` — QMenuItem, QMenuSub, QMenuDivider, QMenuSubheader (row chrome used by both menus)
 * - `QMenu/` — surface + QDropdownMenu (triggerVariant: icon | button)
 * - `QSelect/` — bordered pick control + QSelectButton
 * - `types.ts` — shared family types
 *
 * `QCombobox` (searchable single-select) lives on branch `Ashim/QCombobox` for a later phase.
 */

export { QMenu, QDropdownMenu } from './QMenu';
export { QMenuItem, QMenuSub, QMenuSubheader, QMenuDivider } from './shared';
export { QSelect, QSelectButton, QSelectSelectionRing, Q_SELECT_SELECTION_RING_SX } from './QSelect';

export type {
  QMenuProps,
  QMenuItemProps,
  QMenuItemVariant,
  QMenuSubProps,
  QSelectProps,
  QSelectOption,
} from './types';
export type {
  QDropdownMenuProps,
  QDropdownMenuIconProps,
  QDropdownMenuButtonProps,
} from './QMenu';
export type { QSelectButtonProps } from './QSelect';
